import { withRouter } from "react-router-dom";
import { Component } from "react";

class PageTracker extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      if (window.fbq) {
        window.fbq("track", "PageView");
      }
    }
  }

  render() {
    return null;
  }
}

export default withRouter(PageTracker);
